
	export default {
		async asyncData({ $axios, params }) {
			const res = await $axios.get(`/pomucky/${params.pomucka}`);
			return {
				product: res.data,
			};
		},
		data() {
			return {
				instances: null,
				mainImage: null,
				selectImages: null,
        imageloaded: false,
			};
		},
		mounted() {
			this.$axios.get(`/pomucky/${this.product._id}/instances`).then((res) => {
				if (res.status == 200) {
					this.instances = res.data.instances;
				}
			});
			this.$axios.get(`/pomucky/${this.product._id}/images`).then((res) => {
				if (res.status == 200) {
					if (res.data.length > 0) {
						this.mainImage = `${this.$axios.defaults.baseURL}/pomucky/${this.product._id}/images/${res.data[0]._id}/data`;
						for (let i = 1; i < res.data.length; i++) {
							this.selectImages.push(
								`${this.$axios.defaults.baseURL}${this.product._id}/images/${res.data[i]._id}/data`
							);
						}
					}
				}
			});
		},
	};
